import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { faHeart } from '@fortawesome/free-solid-svg-icons'

export default class VideoPreviewButton extends Component {

	state = {
		open: false
	};

	render() {
    const { title, videoUrl, toggleExerciseFavourite, _id, user, library, favouriteByUsers, isShowFavBtn } = this.props;
    const { open } = this.state;
    const userId = user._id || localStorage.id;
    let isFavourite = false;
    if (favouriteByUsers && favouriteByUsers.length > 0) {
      const findIndex = favouriteByUsers.findIndex((fav) => {
        return fav.userId === userId;
      })
      if (findIndex > -1) {
        isFavourite = true;
      }
    } 

		return (
      <div style={{ marginLeft: 'auto', marginRight: 0 }}>
      <Modal
        className="modal show"
        open={open}
        onClose={() => this.setState({open:false})}
      >

        <div className="modalBody modal-content" style={{width:800}}>
          <ModalHeading
            text={title}
            closeModal={() => this.setState({open:false})}/>
          <div className="modalContent">
            <video controls src={videoUrl}
              style={{width:'100%', maxHeight: 380}} autoPlay loop muted />
          </div>
        </div>
      </Modal>
        <button onClick={() => this.setState({open:true})} style={{
              background: '#fff',
              border: '0'
          }
        }><FontAwesomeIcon 
           icon="eye"
           onClick={() => this.setState({open:true})}
            style={{marginRight: 5, color: COLORS.orange}}/></button>
          { isShowFavBtn &&
         <span
            className="link"
            style={{ float: 'left' }}
            onClick={() => toggleExerciseFavourite({
              exerciseId: _id, 
              isFavourite: isFavourite ? false : true,
              favouriteByUsers,
              userId,
              library
            })}
          >
            <FontAwesomeIcon icon={faHeart} title={isFavourite ? 'Mark as Unfavorite': 'Mark as favorite'}
                style={{ marginRight: 5, color: isFavourite ? COLORS.orange : COLORS.grey }} />
        </span>
      }
      </div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/VideoPreviewButton.js